export default __webpack_public_path__ + "static/media/medical.4d70b612.png";